import moment from "moment-timezone";
import { Accordion, ListGroup } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";

import * as missionApi from "../../api/missionApi";
import MissionListItem from "../../components/MissionListItem";
import TimeDisplay from "../../components/TimeDisplay";

export function groupMissions(missions) {
    const groups = [];
    let currentGroup = [];

    missions.forEach((mission, index) => {
        const missionState = missionApi.getMissionState(mission);
        const isLast = index === missions.length - 1;

        if (missionState === missionApi.STATE_MISSED) {
            currentGroup.push(mission);
            if (isLast) {
                groups.push([...currentGroup]);
            }
        } else {
            if (currentGroup.length > 0) {
                groups.push([...currentGroup]);
                currentGroup = [];
            }

            groups.push([mission]);
        }
    });

    return groups;
}

export default function MissionGroup({
    missions,
    showOrganizationName,
    timeDisplayFormat,
    organizations,
}) {
    const droneIds = Array.from(
        new Set(missions.map((m) => m?.drone?.id).filter(Boolean)),
    );
    const droneIdsText = droneIds.join(", ");

    const sortedMissions = [...missions].sort((a, b) => {
        return a?.timestamp?.seconds - b?.timestamp?.seconds;
    });

    const firstMission = sortedMissions[0];
    const lastMission = sortedMissions[sortedMissions.length - 1];
    const firstTimestamp = firstMission?.timestamp?.seconds;
    const lastTimestamp = lastMission?.timestamp?.seconds;
    const hasTimeRange =
        Number.isFinite(firstTimestamp) && Number.isFinite(lastTimestamp);
    const userTimezone = moment.tz.guess();
    const spansMultipleDays =
        hasTimeRange &&
        !moment
            .unix(firstTimestamp)
            .tz(userTimezone)
            .isSame(moment.unix(lastTimestamp).tz(userTimezone), "day");
    const timeRangeFormat = spansMultipleDays
        ? "YYYY-MM-DD HH:mm:ss"
        : "HH:mm:ss";

    return (
        <ListGroup.Item
            className="p-0 d-flex justify-content-between align-items-center"
            key={missions?.[0]?.id}
        >
            <Accordion style={{ width: "100%" }} className="accordion-flush">
                <Accordion.Item eventKey="0">
                    <Accordion.Button className="h-100 px-4 py-2">
                        <div>
                            <FaExclamationTriangle
                                className="me-3"
                                style={{ color: "#f07e27" }}
                            />
                            {missions.length} missions missed by {droneIdsText}
                            {hasTimeRange && (
                                <>
                                    {" from "}
                                    <TimeDisplay
                                        timestamp={firstTimestamp}
                                        format={timeRangeFormat}
                                        organizationId={
                                            firstMission.organizationId
                                        }
                                        locationId={firstMission.locationId}
                                    />
                                    {" to "}
                                    <TimeDisplay
                                        timestamp={lastTimestamp}
                                        format={timeRangeFormat}
                                        organizationId={
                                            lastMission.organizationId
                                        }
                                        locationId={lastMission.locationId}
                                    />
                                </>
                            )}
                        </div>
                    </Accordion.Button>
                    <Accordion.Body className="p-0">
                        <ListGroup variant="flush">
                            {missions.map((mission, index) => (
                                <MissionListItem
                                    key={mission.id}
                                    mission={mission}
                                    timeDisplayFormat={timeDisplayFormat}
                                    showOrganizationName={showOrganizationName}
                                    organizations={organizations}
                                    className={`ps-5 ${index === missions.length - 1 ? "border-bottom-0" : ""}`}
                                />
                            ))}
                        </ListGroup>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </ListGroup.Item>
    );
}
